/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export const LegalTsPage: React.FC = () => (
  <div
    css={css`
      background-color: #ffffff;
      margin: 60px 20px;
      font-size: 1.3em;
    `}
  >
    <h1>Terms of Service</h1>
    <p>
      Please read our Terms of Service carefully, as they contain important information about your
      rights and obligations. By accessing this website or using the services provided here, you
      automatically accept our Terms of Service.
    </p>
    <p>Last updated: Feb 14, 2021</p>
    <h2>Introduction</h2>
    <p>
      These Terms of Service constitute a binding agreement between you (Customer) and us,
      regulating your access to our website, its use and all applications (Apps).
    </p>
    <h2>Use License</h2>
    <p>
      Under the agreement between you and us, you are entitled to a revocable, non-exclusive,
      limited, non-commercial, non-transferable license for the Apps.
    </p>
    <p>
      The license granted to you does not imply the ability to access other applications or systems.
      It does not authorize you to commercialize, transfer or sublicense, free or paid, the
      Application, Site, or Services to third parties.
    </p>
    <h2>Account Registration</h2>
    <p>
      The Login and password of each Customer serve to ensure your privacy and security. We advise
      our customers not to share this information with anyone. We shall not be liable for any
      damages or losses caused to the Customer by sharing this information.
    </p>
    <h2>Exemptions</h2>
    <p>
      We will be exempt from any responsibility in the event of failure of the operation, operation
      by unauthorized persons or any other cause. There is not our fault.
    </p>
    <p>
      We shall be exempt from any liability in the event of damage or loss arising from
      administrative, managerial or commercial decisions taken based on the information provided by
      the site or application, as well as for any damages.
    </p>
    <p>
      OUR PAPERS, TUTORIALS, LECTURES, CALCULATIONS, RESULTS, TOOLS, MEDIA, SOFTWARE, AND ANY OTHER
      RECOMMENDATION OR CONTENT PRESENT BY US (OUR PRODUCT AND SERVICES) ARE PROVIDED &quot;AS
      IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
      WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT.
      IN NO EVENT SHALL WE BE LIABLE FOR ANY DAMAGES OR OTHER LIABILITY, WHETHER IN CONTRACT, TORT
      OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH OUR PRODUCT AND SERVICES OR THE USE
      OR OTHER DEALINGS WITH OUR PRODUCT AND SERVICES.
    </p>
    <p>
      We will be exempt from any liability in problems defined as a fortuitous event or natural
      causes.
    </p>
    <p>
      TO THE EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL WE BE LIABLE TO YOU OR ANY OTHER
      PARTY IN CONNECTION WITH ANY INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, EXEMPLARY OR
      PUNITIVE DAMAGES ARISING OUT OF OR RELATING TO THIS AGREEMENT, INCLUDING, BUT NOT BEING
      LIMITED ON ANY CLAIM FOR LOSS OF PROFITS, LOSS OF REVENUE, DAMAGE TO THE TRADE FUND, LOSS OF
      SAVINGS OR LOSS OF DATA, EVEN IF WE HAVE BEEN ADVISED ABOUT THE POSSIBILITY OF SUCH DAMAGES.
      IF THE ABOVE LIMITATION OF LIABILITY IS CONSIDERED TO BE INVALIDED IN ACCORDANCE WITH
      APPLICABLE LAW, OUR LIABILITY FOR SUCH CLAIMS SHALL BE LIMITED TO THE AMOUNT OF ZERO DOLLAR.
    </p>
    <h2>Arbitration</h2>
    <p>The regulation should be used in the mediation and arbitration of the case.</p>
    <p>
      The arbitrator shall consider the cost and speed of the chamber to define the place and form
      of mediation or arbitration.
    </p>
    <p>
      Each Party shall remain entitled to apply to the competent common court for judicial measures
      to obtain urgent measures for the protection or protection of the law or preparatory steps,
      without this being interpreted as a waiver of mediation and arbitration.
    </p>
    <h2>About these terms</h2>
    <p>
      We may modify these terms or any additional terms that apply to the Products sold and Services
      provided by us to, for example, reflect changes in the law or changes in how we operate.
    </p>
    <p>The Customer must look at these terms regularly.</p>
    <p>We will post notices of modifications in these terms on our news platforms.</p>
    <p>
      We will post notice of additional modifications in the provided Service. The amendments shall
      not be applied retrospectively and shall enter into force no later than 14 days after
      publication.
    </p>
    <p>
      Changes related to new functions for a Service or changes made for legal reasons will take
      effect immediately.
    </p>
    <p>
      IF YOU DO NOT AGREE TO THE MODIFIED TERMS, THE USE OF OUR SERVICES AND APPLICATIONS SHOULD BE
      DISCONTINUED IMMEDIATELY.
    </p>
    <p>
      If there is a conflict between these terms and the additional terms, the other terms will have
      a preference.
    </p>
    <p>
      These terms govern the relationship between you and us only. They do not create any
      third-party beneficiary rights.
    </p>
    <p>
      If you do not comply with these terms and we do not act immediately, this does not mean that
      we are giving up any rights we may have (how to act in the future).
    </p>
    <p>If a specific term does not become feasible, it will not affect any other term.</p>
  </div>
);
